@if (header$ | async; as header) {
  <header class="auto-vision-header d-flex flex-column">
    <div class="d-flex flex-column align-items-baseline">
      <h2 class="m-0 mb-1 d-flex flex-wrap flex-md-row gap-md-4 align-items-center gap-1" data-test-id="app-auto-vision-details-header-e-header">
        <span role="alert">
          {{ header.title }}
        </span>
        <br class="d-md-none" />
        <small class="ms-0 ms-md-2 me-4 fw-normal">
          {{ header.description }}
        </small>
        <div class="d-flex align-items-baseline sell-details-header__disclosures">
          @if (header.hasRedLight || header.hasYellowLight) {
            <div class="me-2 pt-1 yellow-lights-disclosures">
              @if (header.hasRedLight) {
                <app-condition-indicator
                  variant="red"
                  [conditionIndicatorTranslations]="this.autoVisionDetailsHeaderTranslations.conditionIndicatorTranslations ">
                </app-condition-indicator>
              }
              @if (header.hasYellowLight) {
                <app-vehicle-disclosures-indicator
                  variant="yellow"
                  [vehicleDisclosuresIndicatorTranslations]="this.autoVisionDetailsHeaderTranslations.conditionIndicatorTranslations "
                  [bulletedToolTipContentToolTipOverCount]=true [hideDisclosureCount]=true
                  [vehicleDisclosuresList]="header.yellowLightLabel">
                </app-vehicle-disclosures-indicator>
              }
            </div>
          }
        </div>
        @if (header.odometer && header.odometer !== 0) {
          <app-datalist-item
            class="d-inline-block"
            identifier="vehicle_details_odometer_text"
            label={{autoVisionDetailsHeaderTranslations.odometer}}
            value="{{ header.odometer }} {{autoVisionDetailsHeaderTranslations.distanceUnit}}">
          </app-datalist-item>
        }
      </h2>
      <div class="d-block w-100">
        <div class="d-md-flex justify-content-between">
          <p class="mb-1 mb-md-0 me-auto d-flex gap-4">
            <span class="auto-vision-header__vin">{{ header.vin }}</span>
            <span class="sell-details-header__stock-number-mobile fw-bold"> {{this.autoVisionDetailsHeaderTranslations.stockUnit}} {{header.stockNumber}}</span>
          </p>
          @if (autovisionPrintEmailEnabled) {
            <div class="align-self-end pt-1 email-icon-section d-flex align-items-center pb-1 gap-md-0 gap-3">
              @if (showEmailIcon) {
                <a [attr.aria-label]="autoVisionDetailsHeaderTranslations.ariaLabelEmailVdp"
                  tabindex="0"
                  (click)="goToEmail(header.inventoryItemUuid)"
                  (keydown.enter)="goToEmail(header.inventoryItemUuid)"
                  class="email-icon"
                  data-test-id="app-auto-vision-details-header-e-email"
                  [attr.data-track-name]="'Email Vehicle-' + header.title"
                  >
                  <img src="assets/icons/envelope.svg" alt={{autoVisionDetailsHeaderTranslations.altenvelope}}>
                </a>
              }
              <button
                class="card__print card__icon-button btn-link icon-button ms-md-2 ms-lg-4 p-0 border-0 print-icon-btn"
                data-track-name="button"
                data-track-trigger="print"
                data-track-elem="icon"
                type="button"
                [attr.data-track-name]="'Print Vehicle-' + header.title"
                [attr.aria-label]="autoVisionDetailsHeaderTranslations.ariaLabelPrint"
                (click)="printVDP()"
                data-test-id="app-auto-vision-details-header-e-print"
                >
                <img src="assets/icons/print.svg" class="print-icon">
              </button>
              <button
                printSectionId="{{header.inventoryItemUuid}}"
                ngxPrint
                useExistingCss="true"
                class="d-none"
              ></button>
            </div>
          }
        </div>
      </div>
    </div>
    @if (showPrintContent) {
      <div class="print-content">
        <ng-content *ngTemplateOutlet="printContent"></ng-content>
      </div>
    }
    <ng-template #printContent>
      <div class="wrapper" id="{{header.inventoryItemUuid}}">
        <app-auto-vision-print-vdp
          [images]="images$ | async"
          [header]="header"
          [auctionItem]="auctionItem">
        </app-auto-vision-print-vdp>
      </div>
    </ng-template>
  </header>
}
